import { render, staticRenderFns } from "./afterReview.vue?vue&type=template&id=0c823393&scoped=true"
import script from "./afterReview.vue?vue&type=script&lang=js"
export * from "./afterReview.vue?vue&type=script&lang=js"
import style0 from "./afterReview.vue?vue&type=style&index=0&id=0c823393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c823393",
  null
  
)

export default component.exports